<template functional>
  <div
    :class="[data.class, data.staticClass]"
    class="shape-arrow"
    v-on="listeners">
    <div class="shape-arrow__body">
      <div class="shape-arrow__icon" />
    </div>
  </div>
</template>

<script>
// компонент создан исключительно для единой HTML структуры т.к. шейп содержит в себе больше 1 тега
// стили лежат глобально в commonShapes.scss которая подключается в app.scss
export default {
  name: 'ArrowIcon',
};
</script>
